import styled from '@emotion/styled';
import { MenuItem } from '@mui/material';
import Button from 'components/atoms/Button';
import { colors } from 'theme/colors';

const StyledProfileButton = styled(Button)`
  &,
  &:hover {
    margin-left: 30px;
    background-color: ${colors.primary700};
    border: none;

    & svg {
      color: ${colors.white};
      margin-top: 3px;
      margin-left: 4px;
    }
  }
`;

const MenuItemStyle = styled(MenuItem)`
  '&.muibuttonbase-root': {
    padding: 10px 22px;
  }
  gap: 16px;
`;

export { StyledProfileButton, MenuItemStyle };
